import { render } from "./directions-bike.svg?vue&type=template&id=34d95602?inline"
const script = {}
script.render = render

export default script